import * as React from "react";
import { Typography, Grid, Card, withStyles } from "@material-ui/core";
import { WBSPropertiesStore } from "modules/WBS/WBSPropertiesStore";
import { formatMonetary, formatNumber } from "utils/MathUtils";
import { times } from "utils/DecimalUtils";

const styles = () => ({
  title_content: {
    padding: "20px 20px 5px 20px",
  },
  title: {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: 700,
    color: "#666",
  },
  cards_content: {
    marginLeft: 0,
    padding: 10,
    paddingBottom: 0,
    "& > div": {
      maxWidth: 140,
      paddingBottom: "2px !important",
    },
  },
  card: {
    maxWidth: 130,
    minWidth: 120,
    height: "100%",
    minHeight: "fit-content",
    padding: 8,
    "& .label": {
      fontSize: "0.7rem",
    },
    "& .value": {
      fontWeight: 700,
    },
  },
});

interface IProps {
  task: {
    description: string;
    quantity: number;
    rowCode: string;
    unit: string;
    unitCost: number;
  };
  classes: any;
}

const TaskHeader = ({ task, classes }: IProps) => {
  const qtt = task.quantity || 0;
  const unitCost = task.unitCost || 0;
  const total = times(unitCost, qtt, WBSPropertiesStore.getRules(2));

  return (
    <Grid container direction="row">
      <Grid item className={classes.title_content}>
        <Typography className={classes.title} component="span">
          {task.description}
        </Typography>
      </Grid>
      <Grid container item spacing={16} className={classes.cards_content}>
        <Grid item xs={2}>
          <Card className={classes.card}>
            <Typography className="label">{"Código"}</Typography>
            <Typography className="value">{task.rowCode}</Typography>
          </Card>
        </Grid>
        <Grid item xs={2}>
          <Card className={classes.card}>
            <Typography className="label">{"Quantidade"}</Typography>
            <Typography className="value">{formatNumber(qtt, 2, 5)}</Typography>
          </Card>
        </Grid>
        <Grid item xs={2}>
          <Card className={classes.card}>
            <Typography className="label">{"Unidade"}</Typography>
            <Typography className="value">{task.unit}</Typography>
          </Card>
        </Grid>
        <Grid item xs={2}>
          <Card className={classes.card}>
            <Typography className="label">{"Custo Unitário"}</Typography>
            <Typography className="value">
              {formatMonetary(unitCost)}
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={2}>
          <Card className={classes.card}>
            <Typography className="label">{"Custo Total"}</Typography>
            <Typography className="value">{formatMonetary(total)}</Typography>
          </Card>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(TaskHeader);



// WEBPACK FOOTER //
// ./src/modules/WBS/components/layouts/TaskHeader.tsx